import React from 'react'

import Dropdown from '../../../common/forms/Dropdown/Dropdown.tsx'

type FoldersFilterProps = {
  mealsDropdownOptions: (string | number)[]
  handleSelectionMeals(selected: number | string | null): void
  indexOfMealsDropdownList: number
  energyDropdownOptions: (string | number)[]
  handleSelectionEnergy(selected: number | string | null): void
  indexOfEnergyDropdownList: number
}

const FoldersFilter = React.forwardRef<HTMLDivElement, FoldersFilterProps>(
  (
    {
      mealsDropdownOptions,
      handleSelectionMeals,
      indexOfMealsDropdownList,
      energyDropdownOptions,
      handleSelectionEnergy,
      indexOfEnergyDropdownList
    },
    ref
  ) => {
    const extractor = (item: string | number) => {
      if (typeof item === 'string') {
        return item
      }
      return item.toString()
    }

    return (
      <div
        ref={ref}
        className="inline-flex flex-col gap-4 p-5 dark:border-gray-600 md:flex-row md:items-center"
      >
        <div className="flex xl:flex-row flex-col items-center gap-2">
          <p className="whitespace-nowrap">Liczba posiłków:</p>
          <Dropdown<string | number>
            className="w-full min-w-[240px]"
            options={mealsDropdownOptions}
            labelExtractor={extractor}
            onSelect={handleSelectionMeals}
            placeholder="Wybierz liczbę posiłków"
            optionOnStart={indexOfMealsDropdownList}
          />
        </div>

        <div className="flex xl:flex-row flex-col items-center gap-2">
          <p className="whitespace-nowrap">Liczba kalorii:</p>
          <Dropdown
            className="w-full min-w-[240px]"
            options={energyDropdownOptions}
            labelExtractor={extractor}
            onSelect={handleSelectionEnergy}
            placeholder="Wybierz liczbę kalorii"
            optionOnStart={indexOfEnergyDropdownList}
          />
        </div>
      </div>
    )
  }
)

export default React.memo(FoldersFilter)
